import { render } from "./MatriculaTracking.vue?vue&type=template&id=1706d324&scoped=true"
import script from "./MatriculaTracking.vue?vue&type=script&lang=js"
export * from "./MatriculaTracking.vue?vue&type=script&lang=js"

import "./MatriculaTracking.vue?vue&type=style&index=0&id=1706d324&lang=scss&scoped=true"
import "./MatriculaTracking.vue?vue&type=style&index=1&id=1706d324&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1706d324"]])

export default __exports__